import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
} from "@mui/material";
import React, { useContext, useEffect } from "react";
import { FormProvider, useForm } from "react-hook-form";
import HLTextField from "../../../shared/components/Form/HLTextField";
import { hasDirtyFields } from "../../../shared/helpers/hasDirtyFields";
import { ConfigDataContext } from "../../../shared/providers/ConfigDataProvider";
import { SET_CONFIG_DATA } from "../../../shared/reducer";

type TOpeningHours = Pick<any, "OPENING_HOURS_START" | "OPENING_HOURS_END">;

const OpeningHoursDialog = ({
  handleCloseDialog,
}: {
  handleCloseDialog: () => void;
}) => {
  const { state, dispatch } = useContext(ConfigDataContext);

  const frontendConfig = state?.data as any;

  const methods = useForm<TOpeningHours>({ defaultValues: frontendConfig });
  const {
    formState: { isSubmitSuccessful },
  } = methods;

  const handleSubmit = async (formData: TOpeningHours) => {
    // Add updated opening hours to config data
    const payload = {
      ...state,
      data: {
        ...frontendConfig,
        ...formData,
      },
    };

    dispatch({
      type: SET_CONFIG_DATA,
      payload,
    });
  };

  // Bypass memory leak cause by not consitently mounting dialog
  useEffect(() => {
    if (!isSubmitSuccessful) return;
    handleCloseDialog();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSubmitSuccessful]);

  return (
    <Dialog open onClose={handleCloseDialog}>
      <FormProvider {...methods}>
        <form onSubmit={methods.handleSubmit(handleSubmit)}>
          <DialogContent>
            <HLTextField
              name="OPENING_HOURS_START"
              label="Öffnen from"
              margin="normal"
              type="time"
              required
            />
            <HLTextField
              name="OPENING_HOURS_END"
              label="Öffnen bis"
              margin="normal"
              type="time"
              required
            />
          </DialogContent>
          <DialogActions>
            <Button onClick={handleCloseDialog} color="primary">
              Abbrechen
            </Button>
            <Button
              type="submit"
              color="primary"
              disabled={!hasDirtyFields(methods)}
            >
              Speichern
            </Button>
          </DialogActions>
        </form>
      </FormProvider>
    </Dialog>
  );
};

export default OpeningHoursDialog;
